import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import NavBar from './navBar';

import RestaurantList from '../../../components/restaurantList';

import Pagination from '../../../components/pagination';

import { getRestaurantList } from '../../../../../services/api';

import AreaReports from '../../../components/areaReports';

import Slides from './slides';

const initPagination = {
    pageNumber: 1,
    pageSize: 8,
};

class AreaFestival extends React.PureComponent {
    static propTypes = {
        curArea: PropTypes.string,
        content: PropTypes.object,
    };

    state = {
        searchValue: '',
        list: [],
        total: 0,
        pageNumber: initPagination.pageNumber,
        pageSize: initPagination.pageSize,
    };

    componentDidMount = () => {
        const { pageNumber, pageSize } = this.state;
        const { curArea } = this.props;

        this.asyncGetRestaurantList({
            pageNumber,
            pageSize,
            type: 'areaFestival',
            area: curArea,
        });
    };

    handleSearchChange = searchValue => {
        this.setState({ searchValue });
    };

    handleSearch = () => {
        // console.log(this.state.searchValue);
        const { searchValue } = this.state;
        const { curArea } = this.props;

        this.asyncGetRestaurantList({ ...initPagination, type: 'areaFestival', area: curArea, searchValue });
    };

    handleInitSearch = () => {
        this.setState({ searchValue: '' }, () => {
            const { curArea } = this.props;

            this.asyncGetRestaurantList({
                ...initPagination,
                type: 'areaFestival',
                area: curArea,
            });
        });
    };

    asyncGetRestaurantList = async params => {
        const res = await getRestaurantList(params);

        if (res && res.code === 0) {
            const { list, pageNumber, pageSize, total } = res.data;

            this.setState({ list, pageNumber, pageSize, total });
        }
    };

    handlePageChange = ({ pageNumber, pageSize }) => {
        const { searchValue } = this.state;
        const { curArea } = this.props;

        this.asyncGetRestaurantList({ pageNumber, pageSize, type: 'areaFestival', area: curArea, searchValue });
    };

    render() {
        /**
         * 组件分发数据
         */
        const { searchValue, list, pageNumber, pageSize, total } = this.state;
        const {
            curArea,
            content: { rule, judgesByArea, newsData, posters, showNews },
        } = this.props;

        return (
            <div className={styles.areaFestival}>
                <NavBar
                    searchValue={searchValue}
                    onChange={this.handleSearchChange}
                    onSeach={this.handleSearch}
                    onClear={this.handleInitSearch}
                    content={{ rule, judgesByArea }}
                    curArea={curArea}
                />
                <div style={{ margin: '25px 0 20px' }}>
                    <RestaurantList list={list} />
                </div>
                <Pagination current={pageNumber} total={total} pageSize={pageSize} onChange={this.handlePageChange} />
                {showNews ? (
                    <Fragment>
                        <div className={styles.areaReports}>
                            <div className={styles.navBar}>
                                <div className={styles.header}>区域报道</div>
                            </div>
                            <AreaReports content={newsData} />
                        </div>
                        <Slides content={posters} />
                    </Fragment>
                ) : null}
            </div>
        );
    }
}

export default errorBoundary(AreaFestival);
